import { Loader2 } from 'lucide-react'
import { cn } from '../ui/utils'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  fullScreen?: boolean
  message?: string
  variant?: 'default' | 'minimal'
  className?: string
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-32 w-32',
}

export function LoadingSpinner({
  size = 'md',
  fullScreen = false,
  message,
  variant = 'default',
  className,
}: LoadingSpinnerProps) {
  const spinner = variant === 'minimal' ? (
    <div className={cn('animate-spin rounded-full border-b-2 border-indigo-500', sizeClasses[size], className)} />
  ) : (
    <Loader2 className={cn('animate-spin text-brand-blue', sizeClasses[size], className)} />
  )

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          {spinner}
          {message && (
            <p className="mt-4 text-gray-600 dark:text-gray-400">{message}</p>
          )}
        </div>
      </div>
    )
  }

  if (message) {
    return (
      <div className="flex flex-col items-center justify-center gap-4">
        {spinner}
        <p className="text-muted-foreground">{message}</p>
      </div>
    )
  }

  return spinner
}
